module.exports = __webpack_public_path__ + "static/media/logo-av-w.8456e2c6.svg";